export const tabsDefaultContent = {
    en: {
        tabsTexts: {
            0: {
                title: 'Mindfulness',
                text: 'Mindfulness is the practice of being fully present, engaged in the current moment without judgment. It\'s about embracing each experience, good or bad, and finding peace within it.',
            },
            1: {
                title: 'Awareness',
                text: 'Being truly present means immersing oneself fully in the current experience, free from the distractions of past regrets or future anxieties. It\'s a journey of genuine connection with the now.',
            },
            2: {
                title: 'Presence',
                text: 'Embracing the present is an art that requires patience and practice. It\'s a conscious choice to focus solely on the now, savoring each moment and its unique offerings.',
            }
        }
    },
    es: {
        tabsTexts: {
            0: {
                title: 'Consciencia',
                text: 'La atención plena es la práctica de estar plenamente presente, involucrado en el momento actual sin juzgar. Se trata de aceptar cada experiencia, buena o mala, y encontrar la paz en ella.',
            },
            1: {
                title: 'Conciencia',
                text: 'Estar verdaderamente presente significa sumergirse completamente en la experiencia actual, libre de las distracciones de arrepentimientos pasados o ansiedades futuras. Es un viaje de conexión genuina con el ahora.',
            },
            2: {
                title: 'Presencia',
                text: 'Abrazar el presente es un arte que requiere paciencia y práctica. Es una elección consciente centrarse únicamente en el ahora, saboreando cada momento y sus ofertas únicas.',
            }
        }
    }
}
